import { render, staticRenderFns } from "./config-e-materai.vue?vue&type=template&id=40be7d14&scoped=true"
import script from "./config-e-materai.vue?vue&type=script&lang=ts"
export * from "./config-e-materai.vue?vue&type=script&lang=ts"
import style0 from "./config-e-materai.vue?vue&type=style&index=0&id=40be7d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40be7d14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDataTableHeader } from 'vuetify/lib/components/VDataTable';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VDataTable,VDataTableHeader,VSwitch})
